import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { cloneDeep } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { treeActions } from '../../../redux/slices/treeSlice';
import { getSelectedNodes } from './CopyAndPaste';
import { getUpdatedData as getUpdatedDataInbound } from './NewRecord';
import { getUpdatedData as getUpdatedDataOutbound } from "./NewRecordOutbound";
import { eachDeep } from "deepdash-es/standalone";
import datatypes from '../../../constants/datatypes';
import JsonErrorModal from '../../ItemProperties/Forms/FieldDataValidation/RangeTypes/JsonDeleteError';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { genKey } from '../../../utils/utilFunctions';

function Delete(props) {
  const { openModal, toggle } = props;
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const currentTab = useSelector(state => state.treeData[parentScreen].rightTree.currentTab);
  const { rightTree } = useSelector(state => state.treeData[parentScreen]);
  const templateHeader = rightTree.tree.templateHeader;
  const selectedNode = rightTree.tree[currentTab]?.selectedNode
  const { selectedKeysArray, translatedData } = rightTree.tree[currentTab];
  const { currentScreen }  = useSelector(state => state.treeData)
  const [selectedNodes, setSelectedNodes] = useState([]);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showDialog, setShowDialog] = useState(true);
  const dispatch = useDispatch();

  const handleCancelClick = () => {
   toggle();
  }
  const handleErrorModalClose = () => {
    setError(false);
    setErrorMessage('');
  };
  const handleWorkflowDelete = () => {
    let translatedData = cloneDeep(rightTree.tree[currentTab].translatedData);
    
    // Track SendData items being deleted with their OUTBOUND_IDs
    const deletedSendDataOutboundIds = [];
    
    for (let i = 0; i < selectedNodes.length; i++) {
      // Check if this is a SendData item being deleted
      if (selectedNodes[i].ACTION === 'SEND_DATA' && selectedNodes[i].OUTBOUND_ID) {
        deletedSendDataOutboundIds.push(selectedNodes[i].OUTBOUND_ID);
      }
      
      let parentKey = selectedNodes[i].key.split('-');
      parentKey?.splice(parentKey.length - 1, 1);
      parentKey = parentKey?.join('-');

      eachDeep(translatedData, (objValue) => {
        if (objValue?.key === parentKey) {
          for (let j = 0; j < objValue?.children?.length; j++) {
            if (objValue?.children[j]?.key === selectedNodes[i].key) {
             
                objValue.children.splice(j, 1);
                
                // If deleting an IF condition, also delete associated ELSE
                if (selectedNodes[i].ICON_DISPLAY === 'CONDITION_IF') {
                  const ifValue = selectedNodes[i].nodeId;
                  for (let k = 0; k < objValue.children.length; k++) {
                    if (objValue.children[k].ICON_DISPLAY === 'CONDITION_ELSE' && 
                        objValue.children[k].nodeId === ifValue) {
                      objValue.children.splice(k, 1);
                      break;
                    }
                  }
                }
              break;
            }
          }
        }
      });
    }

    // Clear OUTBOUND_ID from outbound conditions when SendData is deleted
    if (deletedSendDataOutboundIds?.length > 0) {
      eachDeep(translatedData, (obj) => {
        // Find Translate nodes
        if (obj?.ACTION === 'TRANSLATE') {
          
          // Handle CONDITIONAL_TEMPLATE array format 
          if (obj?.CONDITIONAL_TEMPLATE) {
            obj.CONDITIONAL_TEMPLATE?.forEach(conditionalTemplate => {
              if (conditionalTemplate?.OUTBOUND_CONDITION) {
                conditionalTemplate.OUTBOUND_CONDITION?.forEach(outboundCondition => {
                  if (outboundCondition?.OUTBOUND_ID && 
                      deletedSendDataOutboundIds?.includes(outboundCondition.OUTBOUND_ID)) {
                    // Set OUTBOUND_ID to empty string but preserve TEMPLATE and TEMPLATE_LOCATION
                    outboundCondition.OUTBOUND_ID = "";
                  }
                });
              }
            });
          }
          
          // Handle tree children format 
          if (obj?.children) {
            obj.children?.forEach(inboundCondition => {
              if (inboundCondition?.children) {
                inboundCondition.children?.forEach(outboundCondition => {
                  if (outboundCondition?.OUTBOUND_ID && 
                      deletedSendDataOutboundIds?.includes(outboundCondition.OUTBOUND_ID)) {
                    // Set OUTBOUND_ID to empty string but preserve TEMPLATE and TEMPLATE_LOCATION
                    outboundCondition.OUTBOUND_ID = "";
                  }
                });
              }
            });
          }
        }
      });
    }

    dispatch(treeActions.setNewRightTreeTranslatedData({
      screen: parentScreen,
      type: currentTab, 
      data: translatedData
    }));

    dispatch(treeActions.setRightTreeSelectedNode({
      screen: parentScreen,
      type: currentTab,
      data: {}
    }));

    // Select the previous node if available
    if (selectedNodes.length !== 0) {
      let key = selectedNodes?.[0]?.key?.split('-');
      if (key[key.length - 1] === '0') {
        key?.splice(key.length - 1);
        key = key?.join('-');
      } else {
        key[key.length - 1] = Number(key[key.length - 1]) - 1;
        key = key?.join('-');
      }
      let node = getSelectedNodes([key], translatedData);
      if (node[0]) {
        setTimeout(() => {
          dispatch(treeActions.setRightTreeSelectedNode({
            screen: parentScreen,
            type: currentTab,
            data: node[0]
          }));
        });
      } else {
        // If no previous node, select root node
        node = getSelectedNodes(['wf-0'], translatedData);
        setTimeout(() => {
          dispatch(treeActions.setRightTreeSelectedNode({
            screen: parentScreen,
            type: currentTab,
            data: node[0]
          }));
        });
      }
    }
    toggle();
  };
  const deleteNode = () => {
    // For workflow
    if (currentScreen === 'workflow') {
      handleWorkflowDelete();
      return;
    }
    // For header and trailer
    if (currentTab !== 'body' && selectedNodes[0]?.key === 'ib-0' && parentScreen==="inbound") {
      dispatch(treeActions.setNewRightTreeTranslatedData({
        screen: parentScreen,
        type: currentTab,
        data: []
      }));
      dispatch(treeActions.setRightTreeSelectedNode({
        screen:parentScreen,
        type:currentTab,
        data:{}
      }))
      toggle();
      return;
    }
   
    // For Outbound
    if ( (selectedNode?.key === 'ob-0' || selectedNode?.key === 'obh-0' || selectedNode?.key === 'obt-0') && parentScreen==="outbound") {
      dispatch(treeActions.setNewRightTreeTranslatedData({
        screen: parentScreen,
        type: currentTab,
        data: []
      }));
      dispatch(treeActions.setRightTreeSelectedNode({
        screen:parentScreen,
        type:currentTab,
        data:{}
      }))
      toggle();
      return;
    }
    // for body
    let translatedData = cloneDeep(rightTree.tree[currentTab].translatedData);
    for (let i = 0; i < selectedNodes.length; i++) {
      let parentKey = selectedNodes[i].key.split('-');
      parentKey?.splice(parentKey.length - 1, 1);
      parentKey = parentKey?.join('-');

      eachDeep(translatedData, (objValue) => {
        if (objValue?.key === parentKey) {
          for (let j = 0; j < objValue?.children.length; j++) {
            //const NodeIdGenKey = genKey(`${t("LBL_COND_FLD")} ${t("UNNAMED")}`);

            if (objValue?.children[j].ICON_DISPLAY === "CONDITION_ELSE" && objValue?.children[j]?.key === selectedNodes[i].key) {
              objValue?.children?.splice(j, 1);
              break;
            }

           else if (objValue?.children[j].ICON_DISPLAY === "CONDITION_IF" && objValue?.children[j]?.key === selectedNodes[i].key) {
              const ifValue = objValue?.children[j]?.nodeId;
              objValue?.children?.splice(j, 1);
              for (let k = 0; k < objValue?.children.length; k++) {
                if (objValue?.children[k].ICON_DISPLAY === "CONDITION_ELSE" && objValue?.children[k]?.nodeId === ifValue) {
                  objValue?.children?.splice(k, 1);
                }
              }
              break;
            }
            else if (objValue?.children[j]?.key === selectedNodes[i].key) {
              objValue?.children.splice(j, 1);
              break;
            }
          }
        }
      });
    }
    const updatedTranslatedContent = currentScreen === 'inbound' ? getUpdatedDataInbound(translatedData, templateHeader?.FILETYPE) : getUpdatedDataOutbound(translatedData, templateHeader?.FILETYPE, false, parentScreen === "workflow", currentTab);

    dispatch(treeActions.setNewRightTreeTranslatedData({
      screen: parentScreen,
      type: currentTab,
      data: updatedTranslatedContent
    }));
        if (selectedNodes.length !== 0) {
      let key = selectedNodes?.[0]?.key?.split('-');
      if (key[key.length - 1] === '0') {
        key?.splice(key.length - 1)
        key = key?.join('-');
      } else {
        key[key.length - 1] = Number(key[key.length - 1]) - 1;
        key = key?.join('-');
      }
      let node = getSelectedNodes([key], updatedTranslatedContent);
      if (node[0]) {
        dispatch(treeActions.setRightTreeSelectedNode({
          screen: parentScreen,
          type: currentTab,
          data: {}
        }));
        eachDeep(translatedData, (objValue) => {
          if (objValue?.key === key) {
            setTimeout(() => {
              dispatch(treeActions.setRightTreeSelectedNode({
                screen: parentScreen,
                type: currentTab,
                data: node[0]
              }));
            })
          }
        });
      } else {
        node = getSelectedNodes(['ib-0'], updatedTranslatedContent);
        dispatch(treeActions.setRightTreeSelectedNode({
          screen: parentScreen,
          type: currentTab,
          data: {}
        }));
        setTimeout(() => {
          dispatch(treeActions.setRightTreeSelectedNode({
            screen: parentScreen,
            type: currentTab,
            data: node[0]
          }));
        })
      }
    }
    toggle();
  }

  useEffect(() => {
    // Running When there is not any translatedData while switching between templates.
    if (templateHeader?.FILETYPE === "JSON" && ((selectedNode.key?.split("-").length <= 3 && parentScreen === "inbound") || (selectedNode.key?.split("-").length <= 2 && parentScreen === "outbound" && currentTab === "body")) && openModal) {
      setError(true);
      setErrorMessage(t('BOX_CANNOT_DEL_TOP_LEVEL_ITEM'));
      // handleCancelClick();
      setShowDialog(false);
      toggle();
      return;
    }
    if (translatedData?.length) {
      const nodes = getSelectedNodes(selectedKeysArray, translatedData, true);
      const isWorkflowNodePresent = nodes.some(node => node.ICON_DISPLAY === 'OBJECTS' && node.key === 'wf-0');
      
      if (isWorkflowNodePresent && openModal) {
      
        setError(true);
        setErrorMessage(t('BOX_CANNOT_DELETE_WORKFLOW_FROM_HERE'))
        setShowDialog(false);
        handleCancelClick();
        return;
      }
      
      setSelectedNodes(nodes);

    }
    setShowDialog(true);

    return () => {
      setShowDialog(false);
      setError(false);
      setErrorMessage('');
    }
  }, [openModal]);

  return (
    <>
      <Dialog open={showDialog && openModal} maxWidth="xs">
        <DialogTitle className="dialog-header">
          <div className="title">
            {t("BOX_CONFIRM")}
          </div>
        </DialogTitle>
        <DialogContent className="modal-content" dividers>
          {t("BOX_SURE_YOU_WANT_TO_DEL").split(":")[0]}:{" "}
          <br />
          {selectedNodes?.map((selectedNode, index) => (
            <p key={index} className="delete-right-content">
              <b>
                {selectedNode?.title}
              </b>
            </p>
          ))}
        </DialogContent>
        <DialogActions>
          <Button size='small' variant="outlined" color="primary" onClick={deleteNode}>
            {t("APPLY")}
          </Button>
          <Button
            size='small'
            variant="outlined"
            color="primary"
            onClick={handleCancelClick}>
            {t("BTN_CANCEL")}
          </Button>
        </DialogActions>
      </Dialog>
      <JsonErrorModal errorModal={error} handleErrorModal={handleErrorModalClose} errorMessage={errorMessage} />
    </>
  );
}

export default Delete